import { get, post } from '@/lib/api/client'
import {
  PaginationParamsSchema,
  TenderFilterParamsSchema,
  type Tender,
  type TenderDetail,
  type TenderFilterParams,
  type ApiResponse,
  type PaginatedResponse,
  type PaginationParams
} from '@/lib/api/types'

export class TenderService {
  /**
   * Filter tenders with pagination (Public endpoint)
   * POST /tenders/public/filter?page={page}&size={size}
   */
  async getTenders(
    params: PaginationParams = { page: 1, size: 10 },
    filters: TenderFilterParams = {}
  ): Promise<ApiResponse<PaginatedResponse<Tender>>> {
    const validatedParams = PaginationParamsSchema.parse(params)
    const validatedFilters = TenderFilterParamsSchema.parse(filters)

    const query = new URLSearchParams({
      page: validatedParams.page.toString(),
      size: validatedParams.size.toString()
    }).toString()

    return await post<ApiResponse<PaginatedResponse<Tender>>>(
      `tenders/public/filter?${query}`,
      validatedFilters
    )
  }

  /**
   * Search tenders (Public endpoint)
   * GET /tenders/public/search?searchBy={searchTerm}&size={size}&page={page}
   */
  async searchTenders(
    searchTerm: string,
    params: PaginationParams = { page: 1, size: 10 }
  ): Promise<ApiResponse<PaginatedResponse<Tender>>> {
    const validatedParams = PaginationParamsSchema.parse(params)

    const query = new URLSearchParams({
      searchBy: searchTerm,
      size: validatedParams.size.toString(),
      page: validatedParams.page.toString()
    }).toString()

    return await get<ApiResponse<PaginatedResponse<Tender>>>(
      `tenders/public/search?${query}`
    )
  }

  /**
   * Get tender by ID (Public endpoint)
   * GET /tenders/public/{tenderId}
   */
  async getTenderById(tenderId: string): Promise<ApiResponse<TenderDetail>> {
    return await get<ApiResponse<TenderDetail>>(
      `tenders/public/${tenderId}`
    )
  }

  /**
   * Get bid types (Public endpoint)
   * GET /tenders/public/bid-types
   */
  async getBidTypes(): Promise<ApiResponse<Array<{ value: string; displayName: string }>>> {
    return await get<ApiResponse<Array<{ value: string; displayName: string }>>>(
      'tenders/public/bid-types'
    )
  }
}

// Export singleton instance
export const tenderService = new TenderService()

// Export default
export default tenderService


